<template>
  <div>
    <el-card class="page-container">
      <h1 class="title-biaoti">用户属性修改操作</h1>
      <el-row :gutter="20" class="user-options">
        <el-input
          v-model="rid"
          type="number"
          style="width:120px"
          placeholder="请输入rid"
        ></el-input>
        <el-input
          v-model="ver"
          type="number"
          style="width:140px"
          placeholder="请输入版本号"
        ></el-input>
        <el-input
          v-model="register_time"
          type="number"
          style="width:150px"
          placeholder="请输入注册时间"
        ></el-input>
        <el-select
          style="width:120px"
          v-model="is_pay_user"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="vipLevel"
          type="number"
          style="width:150px"
          placeholder="请输入boss等级"
        ></el-input>
        <el-button type="warning" @click="getDayChatDetai">
          修改
        </el-button>
      </el-row>
    </el-card>
    <el-card class="page-container">
      <h1 class="title-biaoti">创建主播账号</h1>
      <el-row :gutter="20" class="user-options">
        <span>agentId:</span>
        <el-input
          v-model="agentId"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="请输入agentId"
        ></el-input>
        <span>账号个数:</span>
        <el-input
          v-model="size"
          type="number"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="请输入账号个数"
        ></el-input>
        <span>归因:</span>
        <el-input
          v-model="sourceName"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="请输入归因"
        ></el-input>
        <span>归因类型:</span>
        <el-input
          v-model="source"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="请输入归因类型"
        ></el-input>
        <span>使用人:</span>
        <el-input
          v-model="user"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="请输入使用人"
        ></el-input>
      </el-row>
      <el-row :gutter="20" class="user-options">
        <span>主播审核状态:</span>
        <el-select
          style="width:130px;margin: 0 10px 10px;"
          v-model="hostStatus"
          placeholder="主播审核状态"
        >
          <el-option
            v-for="item in hostStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span>主播等级:</span>
        <el-select
          style="width:130px;margin: 0 10px 10px;"
          v-model="hostLevel"
          placeholder="主播等级"
        >
          <el-option
            v-for="item in hostLevels"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <span>主播排序分:</span>
        <el-input
          v-model="sortScore"
          style="width:130px;margin: 0 10px 10px;"
          placeholder="主播排序分"
        ></el-input>
        <span>主播在线状态:</span>
        <el-select
          style="width:130px;margin: 0 10px 10px;"
          v-model="onlineStatus"
          placeholder="主播在线状态"
        >
          <el-option
            v-for="item in onlineStatuss"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-row>
      <el-row :gutter="20" class="user-options user-options_">
        <span>描述备注:</span>
        <el-input
          v-model="remark"
          type="textarea"
          :rows="2"
          style="width:200px;margin: 0 10px;"
          placeholder="请输入描述备注"
        ></el-input>
        <el-button type="warning" @click="host_crea">
          创建
        </el-button>
      </el-row>
      <el-row class="user-options user-options_">
        <div v-for="(item, i) in host_id" :key="i">rid: {{ item.rid }}</div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      rid: '',
      ver: '',
      register_time: '',
      is_pay_user: '',
      vipLevel: '',
      options: [
        {
          label: '未选择',
          value: ''
        },
        {
          label: '是',
          value: 1
        },
        {
          label: '否',
          value: 0
        }
      ],
      agentId: '', // 代理id
      size: 1, // 账号个数
      sourceName: '', // 归因
      source: '', // 归因类型
      remark: '', // 描述备注
      user: '', // 使用人
      hostStatus: '', // 主播审核状态
      hostStatuss: [
        {
          label: '一次试用',
          value: 1
        },
        {
          label: '二次试用',
          value: 2
        },
        {
          label: '优质主播',
          value: 3
        },
        {
          label: '淘汰',
          value: 4
        },
        {
          label: '考核不通过淘汰',
          value: 5
        }
      ],
      hostLevel: 0, //主播等级
      hostLevels: [
        {
          label: 'L0',
          value: 0
        },
        {
          label: 'L1',
          value: 1
        },
        {
          label: 'L2',
          value: 2
        },
        {
          label: 'L3',
          value: 3
        }
      ],
      sortScore: '', //主播排序分输入框
      onlineStatus: '', //主播在线状态
      onlineStatuss: [],
      host_id: []
    }
  },
  created () {
    this.queryTypeList()
  },
  methods: {
    // 查询列表
    async getDayChatDetai () {
      if (
        this.ver == '' &&
        this.register_time == '' &&
        this.is_pay_user == ''
      ) {
        return
      }
      let url =
        this.$store.getters.path.items_update +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        rid: this.rid,
        ver: this.ver,
        registerTime: this.register_time,
        vipLevel: this.vipLevel,
        isPayUser: this.is_pay_user
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success(res.msg)
    },
    async queryTypeList () {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.host_online_status,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      })
      if (res.code != 0) return this.$message(res.msg)
      this.onlineStatuss = res.data
    },
    async host_crea () {
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.createHost,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          agentId: this.agentId,
          size: this.size,
          sourceName: this.sourceName,
          source: this.source,
          user: this.user,
          remark: this.remark,
          hostStatus: this.hostStatus,
          hostLevel: this.hostLevel,
          sortScore: this.sortScore,
          onlineStatus: this.onlineStatus
        }
      })
      if (res.code != 0) return this.$message(res.msg)
      this.host_id = res.data.data
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;
  min-width: 1100px;
  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;
    button {
      margin-left: 30px;
    }
    span {
      display: inline-block;
      width 110px;
      text-align: center;
    }
  }
  .user-options_ {
    display: flex;
    align-items: center;
    div {
      margin: 0 20px 20px;
    }
  }

  .display-type {
    margin-top: 20px;

    
  }
}
</style>
